import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useNavigate, useLocation,
} from 'react-router';
import { Typography } from '@equinor/eds-core-react';
import { getAuthServiceSingleton, getLoginErrorMessage } from '../services/authentication/authService';
import { getUserIdentity } from '../store/auth/selectors';
import { reportErrorWithCustomMessage } from '../store/appMessages/actions';
import { SystemMessage } from '../store/appMessages/types';
import brandLogo from '../resources/images/equinor-logo.png';
import userIcon from '../resources/images/userIcon.png';

import packageInfo from '../../package.json';

import './AppHeader.css';
import diwaLogo from '../resources/images/diwalogo.svg';

export function AppHeader() {
  const dispatch = useDispatch();
  const authService = getAuthServiceSingleton();
  const userIdentity = useSelector(getUserIdentity);
  const userDisplayName = userIdentity == null ? '' : `${userIdentity.userName} (${userIdentity.userId})`;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const loginHandler = () => {
    authService.loginUser('', (redirectUrl : string) => navigate(redirectUrl))
      .catch((e) => {
        dispatch(reportErrorWithCustomMessage(new SystemMessage(getLoginErrorMessage(e)), e));
      });
  };

  return (
    <div className="navbar navbar-expand-md app-header">
      <div className="link">
        <div className="brand">
          <a className="nav-link" href={`/${authService.getPopupAuthSearchParameter()}`}>
            <img className="brand-logo" alt="Equinor" src={brandLogo} />
          </a>
        </div>
      </div>

      <div className="collapse navbar-collapse" id="header-menu">
        <ul className="nav navbar-nav">
          <li>
            <a className="nav-link" href={`/${authService.getPopupAuthSearchParameter()}`}>
              <h1>
                <span className="nav-link nav-link-admin">Admin</span>
              </h1>
            </a>
          </li>

          <li className="dropdown position-static">
            {// oxlint-disable-next-line jsx-a11y/anchor-is-valid
              <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">Resources </a>
            }
            <ul className="adminresources dropdown-menu w-100" role="menu">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <Link to="/topics">
                      <div className="dropdown-link-wrap">
                        <Typography variant="h5">Topics management</Typography>
                        <span>Topics management module</span>
                      </div>
                    </Link>
                  </div>
                  <div className="col">
                    {// oxlint-disable-next-line jsx-a11y/anchor-is-valid
                      <a href="#">
                        <div className="dropdown-link-wrap inactive">
                          <Typography variant="h5">Placeholder</Typography>
                          <span>Placeholder description</span>
                        </div>
                      </a>
                    }
                  </div>
                  <div className="col">
                    {// oxlint-disable-next-line jsx-a11y/anchor-is-valid
                      <a href="#">
                        <div className="dropdown-link-wrap inactive">
                          <Typography variant="h5">Placeholder</Typography>
                          <span>Placeholder description</span>
                        </div>
                      </a>
                    }
                  </div>

                </div>
              </div>
            </ul>

          </li>
        </ul>
        <ul className="navbar-nav me-auto">
          {/* <li className="nav-item"><InfoMessagePanel /></li> */}
        </ul>
        {pathname === '/' ? ''
          : <img className="diwa-header-logo" alt="DIWA" src={diwaLogo} />}
        <ul className="navbar-nav ms-auto justify-content-end usermenu">
          <li className="nav-item dropdown">
            {/* TODO: replace Link to Button and remove oxlint-disable */}
            {/* oxlint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="nav-link "
              href="#"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="menu-item">
                <img className="userIcon" alt="user" src={userIcon} />
              </span>
            </a>
            <div className="dropdown-menu dropdown-menu-end navbar-dark">
              <div className="dropdown-header">
                <div>{userDisplayName}</div>
                <div>
                  version:
                  {' '}
                  {packageInfo.version}
                </div>
              </div>
              <div className="dropdown-divider" />
              {authService.isLoggedIn()
                // oxlint-disable-next-line jsx-a11y/anchor-is-valid
                ? <a tabIndex={0} href="#" className="dropdown-item" role="menuitem" onClick={() => { void authService.logout(); }}>Sign out</a>
                // oxlint-disable-next-line jsx-a11y/anchor-is-valid
                : <a tabIndex={0} href="#" className="dropdown-item" role="menuitem" onClick={loginHandler}>Sign in</a>}
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
